import markRobinette from '../../../images/mark-robinette.jpg'

export default {
  markRobinette: {
    name: 'Mark Robinette',
    img: markRobinette,
  },
}
